module.exports = __webpack_public_path__ + "assets/img/WechatIMG61.3b2c77f2.png";